import { render, staticRenderFns } from "./AgoraViewer.vue?vue&type=template&id=27f74916&scoped=true&"
import script from "./AgoraViewer.vue?vue&type=script&lang=js&"
export * from "./AgoraViewer.vue?vue&type=script&lang=js&"
import style0 from "./AgoraViewer.vue?vue&type=style&index=0&id=27f74916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f74916",
  null
  
)

export default component.exports